import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";




@Injectable({
  providedIn: 'root'
})
export class storeDataService {
        
        constructor() {}
        private industriesSub: BehaviorSubject<any> = new  BehaviorSubject<any>([]);
	    private subIndustriesSub: BehaviorSubject<any> = new  BehaviorSubject<any>([]);
        private labelScore: BehaviorSubject<any> = new  BehaviorSubject<any>([]);
        private analyticsInformation: BehaviorSubject<any> = new BehaviorSubject<any>({})
        private scoreDatasubs: BehaviorSubject<any> = new  BehaviorSubject<any>({})
        private stateScoreSub: BehaviorSubject<any> = new  BehaviorSubject<any>({})
        private scores: BehaviorSubject<any> = new  BehaviorSubject<any>([])
        private EEFFTypes: BehaviorSubject<any> = new  BehaviorSubject<any>([])
        private sourceSystems: BehaviorSubject<any> = new  BehaviorSubject<any>([])
        private businessList: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
	    public getIdustries = this.industriesSub.asObservable();
	    public getSubindustries = this.subIndustriesSub.asObservable();
        public getLabelScores = this.labelScore.asObservable();
        public getScoreData = this.scoreDatasubs.asObservable();
        public getScores = this.scores.asObservable();
        public getStatesScore = this.stateScoreSub.asObservable();
        public getAnalytics =  this.analyticsInformation.asObservable();
        public getEEFFTypes = this.EEFFTypes.asObservable();
        public getSourceSystems = this.sourceSystems.asObservable();
        public getBusinessList = this.businessList.asObservable();


        public setAnalyticsInformation(data){
            this.analyticsInformation.next(data)
        }

        public setIdustries( industries ){
	    	this.industriesSub.next( industries );
	    }
    
	    public setSubIdustries( industries ){
	    	this.subIndustriesSub.next( industries );
	    }
    
        public setLabelScores( labelScores ){
            this.labelScore.next( labelScores );
        }

        public setScoreData( scoreData ){
            this.scoreDatasubs.next( scoreData ); 
        }

        public setScores( scores ) {
            this.scores.next(scores);
        }

        public setEEFFTypes(EEFFTypes) {
            this.EEFFTypes.next(EEFFTypes); 
        }

        public setSourceSystems(sourceSystems) {
            this.sourceSystems.next(sourceSystems); 
        }

        public setStatesScore( status ){
	    	this.stateScoreSub.next( status );
	    }

        public setBusinessList(businesses) {
            this.businessList.next(businesses); 
        }        
    }